import React from "react";

import { Box, Typography } from "@material-ui/core";


const Title: React.FC = () => {
    return (
        <>
            <Typography variant="h5" component="div">
                Product store fit setup
            </Typography>
            <Box paddingTop={1}>
                <Typography variant="subtitle1" component="div">
                    Select a store and product to explore headroom potential and assess alignment between product range and store location.
                </Typography>
            </Box>
        </>
    );
};

export default Title;
